class PrivilegeModule extends HTMLElement {
    connectedCallback() {
        this.load();
    }

    load() {
        console.log(this);
    }
}

window.customElements.define("privilege-module", PrivilegeModule, {
    extends: "section",
});
